var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadKsNavActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 9.063h-1.477l-1.312 1.312h2.789a.47.47 0 0 1 .438.438V13a.45.45 0 0 1-.438.438H1.75A.432.432 0 0 1 1.312 13v-2.188a.45.45 0 0 1 .438-.437h2.762L3.199 9.062H1.75c-.984 0-1.75.793-1.75 1.75V13c0 .984.766 1.75 1.75 1.75h10.5c.957 0 1.75-.766 1.75-1.75v-2.188c0-.957-.793-1.75-1.75-1.75zm-.438 2.843c0-.355-.3-.656-.656-.656-.383 0-.656.3-.656.656 0 .383.273.656.656.656a.648.648 0 0 0 .656-.656zM6.535 10.84c.11.137.274.191.465.191a.544.544 0 0 0 .438-.191l3.718-3.719a.599.599 0 0 0 0-.902.599.599 0 0 0-.902 0L7.656 8.816v-7.41c0-.355-.3-.656-.656-.656-.383 0-.656.3-.656.656v7.41L3.719 6.191c-.274-.246-.684-.246-.93 0-.273.274-.273.684 0 .93l3.746 3.719z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadKsNavActive);
export default __webpack_public_path__ + "static/media/download-ks-nav-active.ad3604fa28e38cb7c7f930736ff2c207.svg";
export { ForwardRef as ReactComponent };